import { message } from 'antd'
import { omit, pick } from 'ramda'
import { fetchUtil as fetch, buildQuery } from 'src/utils/fetch'
import { saveAuditData } from 'src/api/audit'
import moment from 'moment'

export const getAll = async (params: Record<string, any>) => {
  const query = buildQuery(pick(['page', 'pageSize'], params))
  const body = omit(['page', 'pageSize'], params)
  try {
    const { data } = await fetch(`/user-profile/search?${query}`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
    return data
  } catch (e) {
    message.error('getAll user error')
  }
}

export const changeUserStatus = async (id, status) => {
  try {
    const response = fetch(`/auth/user/${id}/active`, {
      method: 'PATCH',
      body: JSON.stringify({
        active_status: status,
      }),
    })
    saveAuditData('EDIT', 'MONTHLYMARKETPLACE', id)
    return response
  } catch (error) {
    message.error('user status change error')
  }
}

export const getUsers = async (
  page,
  size,
  username = '',
  providerCountry = ''
) => {
  const requestBody: {
    username?: string
    providerCountry?: string
  } = {}

  if (providerCountry !== '') {
    requestBody.providerCountry = providerCountry
  }

  if (username !== '') {
    requestBody.username = username
  }

  try {
    const { data } = await fetch(
      `/report/user/search?page=${page}&size=${size} `,
      {
        method: 'POST',
        body: JSON.stringify(requestBody),
      }
    )
    return data
  } catch (e) {
    message.error('Get All Users error !')
  }
}
export const getBots = async () => {
  const { data } = await fetch(`/user-profile/bots`)
  return data
}

export const editBot = async (
  id,
  username,
  firstName,
  bio,
  profilePhoto,
  coverPhoto
) => {
  try {
    const input = new FormData()
    input.append(
      'botUserEditDto',
      new Blob(
        [
          JSON.stringify({
            id: id,
            firstName: firstName,
            bio: bio,
          }),
        ],
        {
          type: 'application/json',
        }
      )
    )
    if (profilePhoto !== null && profilePhoto !== undefined) {
      input.append('profilePhoto', profilePhoto)
    }
    if (coverPhoto !== null && coverPhoto !== undefined) {
      input.append('coverPhoto', coverPhoto)
    }

    const { data } = await fetch('/user-profile/bot/edit', {
      method: 'POST',
      body: input,
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData('EDIT', 'BOT-PROFILE', username)
    message.success('Success Bot Profile Edit!')
  } catch (e) {
    message.error('Edit Games Room error!')
  }
}

export const getUserDevices = async (page = 0, size = 10, userId) => {
  try {
    let url = `/user-profile/device/loginUsers?page=${page}&pageSize=${size}`
    if (userId) {
      url += `&userId=${userId}`
    }
    const { data } = await fetch(url)
    return data
  } catch (e) {
    message.error('getUserDevices error !')
  }
}

export const deleteUserDevice = async (item) => {
  try {
    await fetch(`/user-profile/device/${item.userId}`, {
      method: 'DELETE',
    })
    saveAuditData(
      'DELETE',
      'USER-DEVICE',
      JSON.stringify({
        username: item.username,
        imei: item.imei,
      })
    )
    message.success('Delete Device Success!')
  } catch (e) {
    message.error('delete user device error')
  }
}
export const search = async (params: Record<string, any>) => {
  const query = buildQuery(pick(['page', 'pageSize'], params))
  const body = omit(['page', 'pageSize', 'size', 'buttonAction'], params)
  try {
    if (params.buttonAction === 'Generate Pdf') {
      const response = await fetch(
        `/report/user/user-profile-report/generate/pdf`,
        {
          method: 'POST',
          body: JSON.stringify(body),
          filename: `UsersReport_${moment()
            .startOf('day')
            .format('YYYY-MM-DD')}.pdf`,
          responseType: 'blob',
        }
      )
    } else if (params.buttonAction === 'Generate Csv') {
      const response = await fetch(
        `/report/user/user-profile-report/generate/csv`,
        {
          method: 'POST',
          body: JSON.stringify(body),
          responseType: 'blob',
          filename: `UsersReport_${moment()
            .startOf('day')
            .format('YYYY-MM-DD')}.csv`,
          contentType: 'text/csv',
        }
      )
    }
    const { data } = await fetch(`/report/user/search?${query}`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
    return data
  } catch (e) {
    message.error('search User error !')
  }
}
export const usersAccessTypeMetrics = async (params: Record<string, any>) => {
  const query = buildQuery(pick(['page', 'pageSize'], params))
  const body = omit(['page', 'pageSize', 'size', 'buttonAction'], params)
  try {
    const { data } = await fetch(`/report/user/metrics?${query}`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
    return data
  } catch (e) {
    message.error('search User error !')
  }
}
export const usersUsageMetrics = async (params: Record<string, any>) => {
  const query = buildQuery(pick(['page', 'pageSize'], params))
  const body = omit(['page', 'pageSize', 'size', 'buttonAction'], params)
  try {
    const { data } = await fetch(`/report/user/usage-metrics?${query}`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
    return data
  } catch (e) {
    message.error('search User error !')
  }
}

export const getCharacters = async (page = 0, size = 10, name = '') => {
  const requestBody: {
    name?: string
    page: number
    size: number
  } = { page, size }

  if (name !== '') {
    requestBody.name = name
  }
  try {
    const { data } = await fetch(
      `/user-profile/avatar/character/admin?page=${page}&size=${size} `,
      {
        method: 'POST',
        body: JSON.stringify(requestBody),
      }
    )
    return data
  } catch (e) {
    message.error('Get Character error !')
  }
}

export const saveEditCharacter = async (
  id,
  name,
  desc,
  img,
  thumbImage,
  enabled
) => {
  try {
    const input = new FormData()
    input.append(
      'metaverseCharacterEditDto',
      new Blob(
        [
          JSON.stringify({
            id: id,
            name: name,
            description: desc,
            enabled: enabled,
          }),
        ],
        {
          type: 'application/json',
        }
      )
    )
    input.append('image', img)
    input.append('thumbImage', thumbImage)

    const { data } = await fetch('/user-profile/avatar/character/edit', {
      method: 'POST',
      body: input,
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData('EDIT', 'Character', name)
    message.success('Success Character Edit!')
    return 'success'
  } catch (e) {
    message.error('Edit Character error!')
    return 'failed'
  }
}

export const updateUserPoints = async (user, points, reason) => {
  const input: {
    userId: string
    points: number
  } = { userId: user.userId, points }
  try {
    await fetch('/user-profile/points', {
      method: 'PATCH',
      body: JSON.stringify(input),
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData(
      'EDIT',
      'USER_POINTS',
      JSON.stringify({
        points: points,
        userId: user.userId,
        username: user.userName,
        reason: reason,
      })
    )
  } catch (e) {
    message.error(e.meta_data.message)
  }
}
